import Span from '../components/texts/span/Span';
import TruncatedTextWithTooltip from '../components/TruncatedTextWithTooltip/TruncatedTextWithTooltip';
import { economicActivities } from '../mocks/EconomicActivities';

export function buildActivityOrRubroColumn(
  isUruguayEnabled: boolean,
  isInstrumentationEnabled: boolean,
) {
  if (isUruguayEnabled) {
    return {
      name: 'Rubro',
      selector: (row: any) => row.category_type_name ?? '-',
      cell: (row: any) => {
        const displayText = row.category_type_name ?? '-';
        return (
          <TruncatedTextWithTooltip text={displayText}>
            <Span type='3' variant='neutral'>
              {displayText}
            </Span>
          </TruncatedTextWithTooltip>
        );
      },
      width: isInstrumentationEnabled ? '27%' : '32%',
    };
  }

  return {
    name: 'Actividad económica',
    selector: (row: any) => row.activity,
    cell: (row: any) => {
      const found = economicActivities.find(
        (a) => String(a.code) === String(row.activity)
      );
      const displayText = `${row.activity}${found ? ` - ${found.label}` : ''}`;
      return (
        <TruncatedTextWithTooltip text={displayText}>
          <Span type='3' variant='neutral'>
            {row.activity}
            {found ? ` - ${found.label}` : ''}
          </Span>
        </TruncatedTextWithTooltip>
      );
    },
    width: isInstrumentationEnabled ? '27%' : '32%',
  };
}
